module.exports = __webpack_public_path__ + "media/software-interface-remove-2576-2.869d286c.wav";